import { useLanguage } from "@/i18n";

import { MaintenanceBanner } from "./MaintenanceBanner";
import { MaintenanceBlockScreen } from "./MaintenanceBlockScreen";
import { useMaintenanceState } from "./useMaintenanceState";

/**
 * Scheduled-maintenance banner / block screen driven by Firebase Remote Config.
 * Renders nothing until the config loads and nothing when it fails, so an
 * unreachable Firebase never blocks the app.
 */
export const MaintenanceNotice = () => {
  const [locale] = useLanguage();
  const { config, schedule, phase, isDismissed, dismiss, isBypassed, canBypass, bypass } =
    useMaintenanceState();

  if (!config) return null;

  const isBlocked =
    config.enabled || (!!schedule && phase === "inProgress" && schedule.blockDuring);

  if (isBlocked && !isBypassed) {
    // The kill switch alone shows the default texts; a schedule's own texts and times only
    // apply while its window is running.
    return (
      <MaintenanceBlockScreen
        schedule={phase === "inProgress" ? schedule : null}
        locale={locale}
        onBypass={canBypass ? bypass : undefined}
      />
    );
  }

  if (!schedule || phase === "none" || isDismissed) return null;

  return (
    <MaintenanceBanner
      schedule={schedule}
      phase={phase}
      locale={locale}
      onDismiss={schedule.dismissible ? dismiss : undefined}
    />
  );
};
